import React, { useState, useRef, useEffect } from "react";
import {
  FullCard,
  Button,
  Card,
  Spinner,
  Accordion,
} from "../components/CommonComponents";
import { FaFileExcel, FaHtml5, FaRegFilePdf } from "react-icons/fa";
import { BsFiletypeDocx, BsFiletypeMp3, BsFiletypeTxt } from "react-icons/bs";
import { FaPhotoVideo } from "react-icons/fa";
import {
  mmsSearch,
  mmsSearchSpeech,
  mmsSearchFeedback,
  mmsExternal,
} from "../api/serverAPI";
import { TbFileTypePpt } from "react-icons/tb";
import { GrDocumentZip } from "react-icons/gr";
import { FileUploadSearch } from "../components/Fileupload";
import { IoMdMic } from "react-icons/io";
import { BsRecordFill } from "react-icons/bs";
import { HiMiniSpeakerWave } from "react-icons/hi2";
import { LuCopy } from "react-icons/lu";
import { AiFillLike } from "react-icons/ai";
import { AiFillDislike } from "react-icons/ai";
import { LuX } from "react-icons/lu";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import questionIcon from "../assets/questionIcon.svg";
import ansIcon from "../assets/ansIcon.svg";

export const MultiSearch = () => {
  const [query, setQuery] = useState("");
  const [repoType, setRepoType] = useState("");
  const textareaRef = useRef(null);
  const [databases, setDatabases] = useState({
    docs: false,
    image: false,
    audio: false,
    video: false,
  });
  const [base64Data, setBase64Data] = useState([]);
  const [responseAnswer, setResponseAnswer] = useState("");
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [image, setImage] = useState(false);
  const [imageQuestion, setImageQuestion] = useState([]);
  const [textQuery, setTextQuery] = useState("");
  const [feedbackTxt, setFeedbackTxt] = useState("");
  const [feedbackInput, setFeedbackInput] = useState("");
  const [isRecording, setIsRecording] = useState(false);
  const [activeIcon, setActiveIcon] = useState("");
  const [rating, setRating] = useState("none");
  const [base, setBase] = useState([]);
  const [showPopover, setShowPopover] = useState(false);
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [responses, setResponses] = useState([]);
  const [firstQuery, setFirstQuery] = useState("");
  const [followQuery, setFollowQuery] = useState("none");
  const [followUpQuestion, setFollowUpQuestion] = useState("");
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      const scrollHeight = textareaRef.current.scrollHeight;
      if (scrollHeight <= parseInt(window.innerHeight * 0.2)) {
        textareaRef.current.style.height = `${scrollHeight}px`;
        textareaRef.current.style.overflowY = "hidden";
      } else {
        textareaRef.current.style.height = "20vh";
        textareaRef.current.style.overflowY = "auto";
      }
    }
  }, [query]);

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setDatabases((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles(files);
    const previews = files.map((file) => URL.createObjectURL(file));
    setImagePreviews(previews);

    if (files.length > 0) {
      files.forEach((file) => {
        const reader = new FileReader();
        reader.onload = () => {
          const base64String = reader.result.split(",")[1];
          setBase64Data((prev) => [...(prev || []), base64String]);
        };
        reader.readAsDataURL(file);
      });
    }
    event.target.value = null;
  };

  const handleRemoveFile = (index) => {
    const updatedFiles = selectedFiles.filter((_, i) => i !== index);
    setSelectedFiles(updatedFiles);
    const updatedPreviews = imagePreviews.filter((_, i) => i !== index);
    setImagePreviews(updatedPreviews);
    setBase64Data((prev) => prev.filter((_, i) => i !== index));
  };

  const getIconByExtension = (file_name, file_url) => {
    const cleanExtension = file_name
      .split(".")
      .pop()
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");
    switch (cleanExtension) {
      case "pdf":
        return <FaRegFilePdf color="#23479F" size="2em" />;
      case "docx":
        return <BsFiletypeDocx color="#23479F" size="2em" />;
      case "txt":
        return <BsFiletypeTxt color="#23479F" size="2em" />;
      case "xlsx":
        return <FaFileExcel color="#23479F" size="2em" />;
      case "ppt":
        return <TbFileTypePpt color="#23479F" size="2em" />;
      case "mp3":
      case "wav":
        return <BsFiletypeMp3 color="#23479F" size="2em" />;
      case "html":
        return <FaHtml5 color="#23479F" size="2em" />;
      case "zip":
        return <GrDocumentZip color="#23479F" size="2em" />;
      case "png":
      case "jpg":
      case "jpeg":
        return (
          <img
            src={file_url}
            alt={file_name}
            style={{
              width: "40px",
              height: "40px",
              objectFit: "contain",
            }}
          />
        );
      case "mp4":
      case "vid":
      case "avi":
        return <FaPhotoVideo color="#23479F" size="2em" />;
    }
  };

  const overlayStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    width: "100vw",
    position: "fixed",
    top: 0,
    left: 0,
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    zIndex: 1000,
  };
  const getIconColor = (iconName) =>
    activeIcon === iconName ? "text-blue" : "text-gray-600";

  const handleVoice = async () => {
    try {
      const response = await fetch(
        "https://languageapi.krtrimaiq.ai:5502/speech",
        {
          method: "POST",
          body: JSON.stringify({
            cmd: "textOutput",
            payload: {
              text: responseAnswer,
              language: "en",
            },
          }),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const blob = await response.blob();
      const audioUrl = URL.createObjectURL(blob);

      const audioElement = new Audio(audioUrl);

      await audioElement.play();

      audioElement.addEventListener("ended", () => {
        URL.revokeObjectURL(audioUrl);
      });
    } catch (error) {
      console.error("Error playing audio:", error);
    }
  };

  const handleCopy = () => {
    const feedbackText = responseAnswer;
    navigator.clipboard
      .writeText(feedbackText)
      .then(() => {})
      .catch((error) => {});
  };
  const handleLike = async () => {
    setActiveIcon("like");
    setErrorMessage("Thanks for Providing Feedback!");

    const selectedDatabases = Object.keys(databases).filter(
      (db) => databases[db]
    );
    let payload = {
      query: textQuery,
      databases:
        selectedDatabases.length > 0
          ? selectedDatabases
          : ["docs", "image", "audio", "video"],
      response: responseAnswer,
      feedback: 5,
    };

    if (imageQuestion.length > 0 && base.length > 0) {
      payload = {
        query: base[0],
        query_1: textQuery,
        databases: ["image_image"],
        response: responseAnswer,
        feedback: 5,
      };
    }

    try {
      const response = await mmsSearchFeedback(payload);
    } catch (error) {
      console.error("Error in handleDislike:", error);
    } finally {
      setActiveIcon("");
      setErrorMessage("");
    }
  };
  const handleNotlike = () => {
    setShowPopover(true);
  };
  const handleDislike = async (feedback) => {
    setActiveIcon("dislike");
    setLoading(true);

    const selectedDatabases = Object.keys(databases).filter(
      (db) => databases[db]
    );
    let payload = {
      query: textQuery,
      databases:
        selectedDatabases.length > 0
          ? selectedDatabases
          : ["docs", "image", "audio", "video"],
      response: responseAnswer,
      feedbackResponse: feedback,
      feedback: 0,
    };

    if (imageQuestion.length > 0 && base.length > 0) {
      payload = {
        query: base[0],
        query_1: textQuery,
        databases: ["image_image"],
        response: responseAnswer,
        feedbackResponse: feedback,
        feedback: 0,
      };
    }

    try {
      const response = await mmsSearchFeedback(payload);
      const answer = response.data.answer;
      if (answer === "Answer not found") {
        setResponseAnswer("Answer Not Found");
        setLinks([]);
      } else {
        setResponseAnswer(answer[0]);
        const sources = answer[1];
        if (Array.isArray(sources)) {
          const sourcesLinks = sources
            .map((source) => {
              if (source && source.file_name && source.url) {
                return {
                  link: source.url.trim(),
                  displayText: source.file_name.trim(),
                };
              }
              return null;
            })
            .filter(Boolean);
          setLinks(sourcesLinks);
        } else {
          setLinks([]);
        }
      }
    } catch (error) {
      console.error("Error in handleDislike:", error);
    } finally {
      setActiveIcon("");
      setLoading(false);
    }
  };

  const SpeechRecognition =
    window.SpeechRecognition || window.webkitSpeechRecognition;
  let recognition;

  if (SpeechRecognition) {
    recognition = new SpeechRecognition();
    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.lang = "en-US";
  } else {
    alert("Speech Recognition API is not supported in this browser.");
  }

  const handleMicClick = () => {
    if (recognition) {
      recognition.start();

      recognition.onstart = () => {
        console.log("Voice recognition started. Please speak.");
      };

      recognition.onspeechend = () => {
        console.log("Voice recognition ended.");
        recognition.stop();
      };

      recognition.onresult = (event) => {
        const transcript = event.results[0][0].transcript;
        setQuery((prevQuery) => `${prevQuery} ${transcript}`);
        console.log("Transcript: ", transcript);
      };

      recognition.onerror = (event) => {
        console.error("Speech recognition error detected: ", event.error);
        recognition.stop();
      };
    }
  };

  const handleSubmit = async () => {
    if (!query.trim()) {
      setErrorMessage("Question cannot be empty");
      return;
    }

    let currentFirstQuery = firstQuery;
    let currentFollowQuery = followQuery;

    if (!currentFirstQuery) {
      currentFirstQuery = query;
      setFirstQuery(query);
    } else {
      currentFollowQuery = query;
      setFollowQuery(query);
    }

    console.log("First Query:", currentFirstQuery);
    console.log("Follow-Up Query:", currentFollowQuery);

    if (repoType === "") {
      setErrorMessage("Select Repository Type");
      return;
    }

    setImageQuestion([]);
    setBase(base64Data);
    setImage(false);
    setActiveIcon("");
    setErrorMessage("");
    setTextQuery(query);

    let payload = {};
    if (repoType === "krtrimaiq") {
      const selectedDatabases = Object.keys(databases).filter(
        (db) => databases[db]
      );
      payload = {
        query: query,
        databases:
          selectedDatabases.length > 0
            ? selectedDatabases
            : ["docs", "image", "audio", "video"],
        feedback: "none",
      };

      if (imagePreviews.length > 0 && base64Data.length > 0) {
        payload = {
          query: base64Data[0],
          query_1: query,
          databases: ["image_image"],
          feedback: "none",
        };
      }
    } else if (repoType === "external") {
      payload = {
        query: currentFirstQuery,
        follow_up_query: currentFollowQuery,
      };
    }

    setLoading(true);

    try {
      let response;
      let newResponseEntry = {};

      if (repoType === "krtrimaiq") {
        response = await mmsSearch(payload);
        const data = response.data;
        const answer = data.answer;
        const followQuestion = data.follow_up_questions;

        const sourcesLinks = Array.isArray(answer[1])
          ? answer[1]
              .map((source) =>
                source?.file_name && source?.url
                  ? {
                      link: source.url.trim(),
                      displayText: source.file_name.trim(),
                    }
                  : null
              )
              .filter(Boolean)
          : [];

        newResponseEntry = {
          index,
          question: query,
          answer: answer[0] || "Answer Not Found",
          followUpQuestion: followQuestion,
          links: sourcesLinks,
        };

        if (imagePreviews.length > 0) {
          setImagePreviews(imagePreviews);
          setImageQuestion(imagePreviews);
          setImage(true);
        }
      } else if (repoType === "external") {
        response = await mmsExternal(payload);
        const data = response.data;

        newResponseEntry = {
          index,
          question: query,
          answer: data.answer,
          followUpQuestion: data.follow_up_questions,
          links: [],
        };
      }

      setResponses((prevResponses) => [...prevResponses, newResponseEntry]);
      setIndex((prevIndex) => prevIndex + 1);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
      setQuery("");
      setSelectedFiles([]);
      setBase64Data([]);
      setImagePreviews([]);
      setFollowQuery("");
    }
  };

  return (
    <>
      {loading && (
        <div style={overlayStyle}>
          <Spinner />
        </div>
      )}
      <div className="flex gap-4">
        <div className="secondcardWidth">
          <FullCard>
            <div className="subheading text-center mt-2 mb-8">Search</div>
            <div className="mt-8">
              <div className="text-lg font-medium text-indigo-800 text-left my-2">
                Choose Repository
              </div>
              <select
                className="inline-flex w-[13vw] rounded-md border px-4 py-2 text-sm"
                value={repoType}
                onChange={(e) => setRepoType(e.target.value)}
              >
                <option value="" hidden>
                  Repository Type
                </option>
                <option value="krtrimaiq">KrtrimaIQ</option>
                <option value="external">External Sources</option>
              </select>
            </div>
            <div className="text-lg font-medium text-indigo-800 text-left my-4">
              Choose Document Type
            </div>
            <div className="px-5">
              <div
                className={
                  imagePreviews.length > 0 || repoType === "external"
                    ? "opacity-50"
                    : ""
                }
              >
                {["docs", "image", "audio", "video"].map((type) => (
                  <label key={type} className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      className="transform scale-150"
                      name={type}
                      onChange={handleCheckboxChange}
                      disabled={
                        imagePreviews.length > 0 || repoType === "other"
                      }
                    />
                    <span>{type.charAt(0).toUpperCase() + type.slice(1)}</span>
                  </label>
                ))}
              </div>
            </div>
          </FullCard>
        </div>

        <div className="thirdcardWidth overflow-y-auto h-[90vh]">
          <div
            className="chat-container"
            style={{
              marginBottom: "8rem",
            }}
          >
            <div className="space-y-2">
              {responses.map((responseItem) => (
                <Accordion key={responseItem.index} index={responseItem.index}>
                  <div className="chat-message">
                    <div className="subheading text-left px-[2%]">
                      {responseItem.index === 0
                        ? "Asked Question"
                        : "Asked Follow-up Question"}
                    </div>
                    <div className="m-5">
                      <div className="flex">
                        <div className="w-1/12">
                          <img
                            src={questionIcon}
                            alt=""
                            width={"50px"}
                            height={"50px"}
                          />
                        </div>
                        <div className="w-11/12 ml-4 bg-white rounded-lg text-xl">
                          <div className="w-full border border-light-purple p-2">
                            <p>{responseItem.question}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="chat-message">
                    <div className="m-5">
                      <div className="flex">
                        <div className="w-1/12">
                          <img
                            src={ansIcon}
                            alt=""
                            width={"50px"}
                            height={"50px"}
                          />
                        </div>
                        <div className="w-11/12 ml-4 bg-white rounded-lg text-xl">
                          <div className="w-full border border-light-purple p-2">
                            <p className="w-[45vw] text-lg">
                              {responseItem.answer}
                            </p>

                            {responseItem.links?.length > 0 && (
                              <>
                                {responseItem.links.map((source, idx) => (
                                  <div
                                    key={idx}
                                    className="flex items-center mt-2"
                                  >
                                    {getIconByExtension(
                                      source.displayText,
                                      source.link
                                    )}
                                    <a
                                      href={source.link}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="ml-2 text-blue-500 hover:underline"
                                    >
                                      {source.displayText}
                                    </a>
                                  </div>
                                ))}
                              </>
                            )}
                          </div>
                        </div>
                       
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-row mt-2 mb-2 pl-10">
                        <div className="flex space-x-4">
                          <HiMiniSpeakerWave
                            className="text-gray-600 w-6 h-6 cursor-pointer opacity-50"
                            onClick={handleVoice}
                          />
                          <LuCopy
                            className="text-gray-600 w-6 h-6 cursor-pointer opacity-50"
                            onClick={handleCopy}
                          />
                          <AiFillLike
                            className={`${getIconColor(
                              "like"
                            )} w-6 h-6 cursor-pointer opacity-50`}
                            onClick={handleLike}
                          />
                          <AiFillDislike
                            className={`${getIconColor(
                              "dislike"
                            )} w-6 h-6 cursor-pointer opacity-50`}
                            onClick={handleNotlike}
                          />
                        </div>

                        {showPopover && (
                          <div className="mt-2 p-4 bg-white  rounded-md border border-gray-200 w-[80vh]">
                            <div className="flex justify-between items-center mb-2">
                              <p className="text-gray-700">Tell us more:</p>
                              <LuX
                                className="text-gray-500 hover:text-gray-800 cursor-pointer"
                                onClick={() => setShowPopover(false)}
                              />
                            </div>
                            <div className="flex flex-wrap gap-2">
                              {[
                                "Need More Details",
                                "Incorrect/misleading Information",
                                "Too Complex/Need Simplification",
                                "Too Brief/Need elaboration",
                                "More...",
                              ].map((option) => (
                                <button
                                  key={option}
                                  className="bg-gray-100 hover:bg-gray-200 text-gray-800 py-1 px-2 rounded cursor-pointer"
                                  style={{
                                    flex: "1 1 calc(33.33% - 8px)",
                                    minWidth: "35%",
                                  }}
                                  onClick={() => {
                                    if (option === "More...") {
                                      setShowMoreModal(true);
                                    } else {
                                      setFeedbackTxt(option);
                                      setShowPopover(false);
                                      handleDislike(option);
                                    }
                                  }}
                                >
                                  {option}
                                </button>
                              ))}
                            </div>
                          </div>
                        )}

                        {showMoreModal && (
                          <div className="fixed inset-0 z-20 flex items-center justify-center bg-black bg-opacity-50">
                            <div className="bg-white p-6 rounded-lg shadow-lg w-[50vh]">
                              <div className="flex justify-between items-center mb-4">
                                <p className="text-gray-700">
                                  Please provide us more feedback:
                                </p>
                                <LuX
                                  className="text-gray-500 hover:text-gray-800 cursor-pointer"
                                  onClick={() => setShowMoreModal(false)}
                                />
                              </div>
                              <textarea
                                rows="2"
                                className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:border-blue-400"
                                placeholder="Your feedback here..."
                                value={feedbackInput}
                                onChange={(e) =>
                                  setFeedbackInput(e.target.value)
                                }
                              ></textarea>
                              <div className="mt-4 flex justify-end">
                                <button
                                  className="bg-blue text-white py-2 px-4 rounded hover:bg-blue-600"
                                  onClick={() => {
                                    setFeedbackTxt(feedbackInput);
                                    handleDislike(feedbackInput);
                                    console.log(
                                      "Feedback submitted:",
                                      feedbackInput
                                    );
                                    setFeedbackTxt("");
                                    setShowMoreModal(false);
                                    setShowPopover(false);
                                  }}
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      {responseItem.followUpQuestion && (
                              <div className="p-2 border rounded-md w-fit">
                                {responseItem.followUpQuestion}
                              </div>
                            )}
                </Accordion>
              ))}
            </div>

            <div className="fixed bottom-0 thirdCard bg-[#e5eeff]">
              <div className="mr-10 ml-4 mb-6">
                <div className="flex">
                  <div className="w-full text-lg">
                    <div className="flex items-center mt-8 w-[55vw] space-x-4">
                      <div className="relative flex-grow bg-[#ffffff] rounded-lg z-90">
                        <FileUploadSearch
                          onChange={handleFileChange}
                          accept="image/*"
                        />
                        <div className="relative w-full border-blue-600 rounded-lg ml-12 py-3 flex flex-col space-y-2">
                          {imagePreviews.length > 0 && (
                            <div className="flex space-x-2">
                              {imagePreviews.map((src, index) => (
                                <div key={index} className="relative">
                                  <img
                                    src={src}
                                    alt={`Preview ${index}`}
                                    className="h-16 w-16 object-cover rounded-lg border-2 border-blue-600"
                                  />
                                  <button
                                    onClick={() => handleRemoveFile(index)}
                                    className="absolute top-0 right-0 bg-red-600 text-white rounded-full p-1 h-5 w-5 flex items-center justify-center text-xs hover:bg-red-700"
                                  >
                                    X
                                  </button>
                                </div>
                              ))}
                            </div>
                          )}
                          <div className="relative flex pr-2">
                            <textarea
                              ref={textareaRef}
                              className="border-none focus:ring-0 focus:outline-none text-lg resize-none w-[45vw]"
                              placeholder="Enter your query here..."
                              value={query}
                              onChange={(e) => setQuery(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter" && !e.shiftKey) {
                                  e.preventDefault();
                                  handleSubmit();
                                }
                              }}
                              rows={1}
                              style={{ maxHeight: "20vh" }}
                            />

                            <div onClick={handleMicClick}>
                              <IoMdMic size={25} className="text-blue-600" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="ml-4">
                        <Button onClick={handleSubmit}>Ask</Button>
                      </div>
                    </div>
                    {errorMessage && (
                      <div className="text-red-600 mt-2">{errorMessage}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MultiSearch;
